import {Module, Component} from '../decorators';

import elementsTpl from './nutrients.tpl.html';

@Module({
    name: "app.orders.compontents.nutrients",
})
@Component({
    selector: 'blnd-nutrients',
    template: elementsTpl,
    bindings: {
        ngModel: '=',
        editMode: '=',
        errors: '=?',
        nutrientReCalc: '=?',
        showPrices: '=?',
        ngChange: '&?',
    },
})
export default class NutrientsComponent {
    constructor ($element) {
        "ngInject";
        this.$element = $element;
        this.showPrices = this.showPrices || false;
    }

    onChange () {
        if (this.ngChange) {
            this.ngChange();
        }
    }

    $onDestroy () {
        this.$element.remove();
        this.$element = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/orders/nutrients.component.js